import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next'

const PrivacyStatement = ({ t, i18n }) => {
  const foipop = useMemo(() => {
    return i18n.language === 'en' ? t('privacy_notice.para1_foipop') : <i lang="en">{t('privacy_notice.para1_foipop')}</i>
  }, [t, i18n.language])

  const foipopAbbr = useMemo(() => {
    return i18n.language === 'en' ? t('privacy_notice.para1_foipop_abbr') : <i lang="en">{t('privacy_notice.para1_foipop_abbr')}</i>
  }, [t, i18n.language])

  return (
    <div className="row" style={{ marginTop: '1rem' }}>
      <div className="col-xs-12">
        <h2>{t('privacy_notice.page_title')}</h2>
        <p>
          {t('privacy_notice.para1')}
          {foipop}
          {foipopAbbr}
          {t('privacy_notice.para1_foipop_cont')}
        </p>
        <p>{t('privacy_notice.para1_other')}</p>
        <p>
          {t('privacy_notice.para2')}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'}
          >
            {' '}
            {t('privacy_notice.privacy_statement_link')}
            <span className="ns-visually-hidden">{t('shared.opens_in_new_tab')}</span>
          </a>
          {t('privacy_notice.para2_cont')}.{t('privacy_notice.para3')}
          <a href="mailto:askus@novascotia.ca">{t('privacy_notice.ask_novascotia')}</a>.
        </p>
      </div>
    </div>
  )
}

export default withTranslation('common')(PrivacyStatement)
